
// 速度递减算法
Math.easeInOutQuad = function (t, b, c, d) {
	t /= d / 2;
	if (t < 1) {
		return c / 2 * t * t + b;
	};
	t--;
	return -c / 2 * (t * (t - 2) - 1) + b;
};


// 采用的动画方案
var requestAnimFrame = (function () {
	return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || function (callback) { window.setTimeout(callback, 1000 / 60) }
})();


// 滚动页面所有
function move(amount) {
	document.documentElement.scrollTop = amount;
	document.body.parentNode.scrollTop = amount;
	document.body.scrollTop = amount;
}

// 页面滚动位置
function position() {
	return document.documentElement.scrollTop || document.body.parentNode.scrollTop || document.body.scrollTop;
}


// 滚动执行方法
export function scrollTo(to, duration, callback) {
	const start = position();
	const change = to - start;
	const increment = 20;
	let currentTime = 0;
	duration = (typeof (duration) === 'undefined') ? 500 : duration;
	var animateScroll = function () {
		// 滚动时间递增
		currentTime += increment;
		// 滚动距离递减
		var val = Math.easeInOutQuad(currentTime, start, change, duration);
		// 移动页面所有
		move(val);
		// 持续动画结束
		if (currentTime < duration) {
			requestAnimFrame(animateScroll);
		} else {
			if (callback && typeof (callback) === 'function') {
				// 执行完成后回调
				callback();
			}
		}
	};
	animateScroll();
}



// WEBPACK FOOTER //
// ./src/utils/scroll-to.js